import { Component, Input, OnInit } from '@angular/core';
import { WccIntegrationStatusType } from "@shared/enums/wcc-integration-status-type.enum";
import { ShipmentStatus } from "@shared-features/enums/shipment-status.enum";
import { Shipment } from '@shared-features/models/shipment';
import { ShipmentList } from '@features/shipments/models/shipment-list';

type ClassName =
  | 'primary'
  | 'secondary'
  | 'accent'
  | 'success'
  | 'info'
  | 'warning'
  | 'warning-alt'
  | 'accent-alt'
  | 'danger'
  | 'danger-alt';

@Component({
  selector: 'app-shipment-status-label',
  templateUrl: './shipment-status-label.component.html',
  styleUrls: ['./shipment-status-label.component.scss']
})
export class ShipmentStatusLabelComponent implements OnInit {
  @Input() value: ShipmentStatus;
  @Input() shipmentStatus: any = ShipmentStatus;
  @Input() shipment: Shipment | ShipmentList;
  @Input() statusTranslationKey = 'Enum.ShipmentStatus';
  @Input() generateClassMap: () => ({[k: string]: ClassName });
  classMap: { [k: string]: ClassName } = {};
  WccIntegrationStatusType = WccIntegrationStatusType;


  ngOnInit(): void {
    this.classMap = this.generateClassMap ? this.generateClassMap() : this.generateDefaultClasses();
  }

  private generateDefaultClasses(): { [k: string]: ClassName } {
    return {
      [ShipmentStatus.New]: 'primary',
      [ShipmentStatus.ArriveDropOffLocation]: 'secondary',
      [ShipmentStatus.Accepted]: 'success',
      [ShipmentStatus.GoodsLoaded]: 'accent',
      [ShipmentStatus.Assigned]: 'warning',
      [ShipmentStatus.InTransit]: 'accent-alt',
      [ShipmentStatus.Rejected]: 'danger',
      [ShipmentStatus.Canceled]: 'danger',
      [ShipmentStatus.NotFulfilled]: 'danger-alt',
      [ShipmentStatus.Closed]: 'danger',
      [ShipmentStatus.GoodsDelivered]: 'success',
      [ShipmentStatus.ArrivePickupLocation]: 'warning-alt',
    };
  }
}
